import type { Messages } from './en';

/**
 * हिंदी — the second catalogue. Shop-floor words people already use (VMC, T0, PIN,
 * wire cut) stay as they are; everything else is plain Hindi.
 */
export const hi: Messages = {
  app: {
    name: 'टूल ट्रैकर',
    product: 'SaarthiOS PACE',
    tagline: 'टूल डेवलपमेंट का प्लान बनाम असली',
  },
  common: {
    of: 'में से',
    back: 'वापस',
    cancel: 'रद्द करें',
    save: 'सेव करें',
    close: 'बंद करें',
    confirm: 'पक्का करें',
    undo: 'वापस लें',
    undone: 'वापस लिया',
    retry: 'फिर कोशिश करें',
    loading: 'लोड हो रहा है…',
    change: 'बदलें',
    edit: 'बदलें',
    add: 'जोड़ें',
    all: 'सभी',
    yes: 'हाँ',
    no: 'नहीं',
    today: 'आज',
    yesterday: 'कल',
    daysAgo: '{n} दिन पहले',
    ext: 'एक्सटेंशन {ext}',
    by: '{name} द्वारा',
    delete: 'हटाएँ',
    show: 'दिखाएँ',
    none: '—',
    optional: 'वैकल्पिक',
    note: 'नोट',
    photo: 'फ़ोटो',
    photos: 'फ़ोटो',
    addPhoto: 'फ़ोटो जोड़ें',
    download: 'डाउनलोड',
    days: '{n} दिन',
    workingDays: '{n} कार्य दिवस',
    search: 'खोजें',
    details: 'विवरण',
    somethingWrong: 'कुछ गड़बड़ हुई। फिर कोशिश करें।',
    notFound: 'पेज नहीं मिला',
    goHome: 'मेरे काम पर जाएँ',
    notAllowed: 'यह स्क्रीन आपकी भूमिका में नहीं है।',
    offlineRead: 'ऑफ़लाइन — आखिरी सेव डेटा दिख रहा है।',
  },
  roles: {
    owner: 'स्टेज ओनर',
    planner: 'प्लानर',
    mgmt: 'मैनेजमेंट',
    admin: 'एडमिन',
  },
  status: {
    DONE: 'पूरा',
    DONE_LATE: 'देर से पूरा',
    OVERDUE: 'देरी',
    DUE_TODAY: 'आज तक',
    AT_RISK: 'खतरे में',
    UPCOMING: 'आने वाला',
    HOLD: 'रुका हुआ',
    SKIPPED: 'लागू नहीं',
  },
  pstatus: {
    ON_TRACK: 'समय पर',
    AT_RISK: 'खतरे में',
    LATE: 'देरी में',
    SHIPPED: 'भेज दिया',
    DRAFT: 'ड्राफ्ट',
    CANCELLED: 'रद्द',
  },
  slip: {
    late: '+{n}दिन',
    early: '−{n}दिन',
    onTime: 'समय पर',
    lateLong: '{n} दिन देर',
    earlyLong: '{n} दिन पहले',
  },
  login: {
    tapYourName: 'अपना नाम चुनें',
    enterPin: 'अपना 4 अंकों का PIN डालें',
    wrongPin: 'गलत PIN। {n} कोशिश बाकी, फिर खाता 15 मिनट के लिए लॉक होगा।',
    wrongPinShort: 'गलत PIN। फिर कोशिश करें।',
    locked: 'बहुत बार गलत PIN। {time} तक लॉक। एडमिन से अनलॉक करवाएँ।',
    notYou: 'आप नहीं हैं?',
    firstTime: 'पहली बार? अपना PIN बनाएँ',
    noPin: 'आपने अभी PIN नहीं बनाया है।',
    setUpNow: 'अभी बनाएँ',
    sharedDevice: '{label} · {role} का साझा डिवाइस',
    pairTitle: 'टूल रूम के साझा डिवाइस के रूप में सेट करें',
    pairHint: 'एडमिन → डिवाइस से मिला 6 अंकों का कोड डालें।',
    pairButton: 'डिवाइस जोड़ें',
    pairDone: 'यह डिवाइस अब {role} का साझा डिवाइस है।',
    demoPin: 'हर यूज़र का डेमो PIN: {pin}',
    loginFailed: 'लॉग इन नहीं हुआ। कनेक्शन जाँचें और फिर कोशिश करें।',
    welcomeBack: 'फिर से स्वागत है',
  },
  setup: {
    title: 'पहली बार सेटअप',
    mobile: 'आपका मोबाइल नंबर',
    mobileHint: 'जो नंबर एडमिन ने आपके लिए दर्ज किया है।',
    sendOtp: 'कोड भेजें',
    otpSentTo: '{mobile} पर 6 अंकों का कोड भेजा गया है।',
    enterOtp: '6 अंकों का कोड डालें',
    demoOtp: 'डेमो कोड: {code}',
    verify: 'जाँचें',
    choosePin: '4 अंकों का PIN चुनें',
    confirmPin: 'वही PIN फिर से डालें',
    pinsDontMatch: 'दोनों PIN अलग हैं। फिर से शुरू करें।',
    weakPin: 'बहुत आसान है। दूसरा PIN चुनें।',
    done: 'PIN बन गया। आप लॉग इन हैं।',
    wrongOtp: 'गलत कोड। SMS देखकर फिर डालें।',
    expired: 'कोड की समय सीमा खत्म। नया कोड मँगाएँ।',
    resend: 'नया कोड भेजें',
    step: 'चरण {n} / 3',
  },
  shell: {
    synced: 'सिंक हो गया',
    syncing: 'सिंक हो रहा है…',
    pending: '{n} सिंक बाकी',
    offline: 'ऑफ़लाइन',
    offlineQueued: 'ऑफ़लाइन — आपके टैप सेव हैं, नेटवर्क आते ही सिंक होंगे।',
    waitingOnYou: '{n} बाकी',
    logout: 'लॉग आउट',
    language: 'भाषा',
    workingAs: 'किस रूप में काम',
    profile: 'प्रोफ़ाइल',
    sessionEnds: 'सेशन {time} पर खत्म होगा',
    sharedIdle: '15 मिनट इस्तेमाल न होने पर लॉग आउट',
    me: 'मैं',
    views: 'दृश्य',
    collapse: 'मेनू छोटा करें',
    expand: 'मेनू बड़ा करें',
    sync: 'सिंक',
    allSaved: 'सब बदलाव सेव · {time}',
    updateReady: 'नया वर्ज़न तैयार है।',
    reload: 'रीलोड करें',
    liveOff: 'लाइव अपडेट रुका — दोबारा जुड़ रहा है…',
    sessionEnded: 'सेशन खत्म हुआ। फिर से PIN डालें।',
    theme: 'थीम',
    themeAuto: 'ऑटो',
    themeLight: 'लाइट',
    themeDark: 'डार्क',
    version: 'वर्ज़न {v}',
    actions: 'विकल्प',
    closeActions: 'विकल्प बंद करें',
  },
  work: {
    title: 'मेरा काम',
    todo: 'करना है',
    coming: 'आगे',
    done: 'पूरा',
    overdue: 'देरी',
    dueToday: 'आज तक',
    thisWeek: 'अगले 7 दिन',
    later: 'बाद में',
    onHold: 'रुका हुआ',
    waitingFor: '{stage} के बाद',
    waitingPrev: 'पिछले स्टेज का इंतज़ार',
    doneToday: 'आज पूरा',
    doneOn: 'इस दिन पूरा…',
    hold: 'रोकें',
    resume: 'फिर शुरू',
    notDone: 'अभी पूरा नहीं',
    changeDate: 'तारीख बदलें',
    planned: 'प्लान {date}',
    forecast: 'अब अनुमान {date}',
    doneDate: '{date} को पूरा',
    allClear: 'सब साफ़',
    noTodo: 'इस हफ़्ते आपके स्टेज में कुछ बाकी नहीं। प्रोजेक्ट प्रकाशित होते ही नया काम यहाँ दिखेगा।',
    noComing: 'आपके स्टेज के लिए अभी और कुछ प्लान नहीं है।',
    noDone: 'पिछले 30 दिनों में कुछ पूरा नहीं हुआ।',
    noDepartments: 'आपको अभी किसी विभाग में नहीं जोड़ा गया है। एडमिन से अपना विभाग जुड़वाएँ।',
    savedDone: '{stage} · {tool}: {date} को पूरा',
    savedHold: '{stage} · {tool}: रुका ({reason})',
    savedResume: '{stage} · {tool}: फिर शुरू',
    savedReopen: '{stage} · {tool}: पूरा नहीं माना',
    locked: 'अगला स्टेज शुरू हो चुका है। बदलने के लिए प्लानर ({name}) से कहें।',
    whenDone: 'कब पूरा हुआ?',
    pickDate: 'तारीख चुनें',
    noteOptional: 'नोट (वैकल्पिक)',
    notePlaceholder: 'जैसे वेंडर को भेजा, पंच पर दोबारा काम',
    holdTitle: 'क्यों रुका है?',
    oneTapSaves: 'कारण पर एक टैप से सेव।',
    photoAdded: 'फ़ोटो जुड़ गई',
    photoNeedsNet: 'फ़ोटो के लिए नेटवर्क चाहिए। ऑनलाइन होने पर फिर कोशिश करें।',
    myDepartments: 'मेरे स्टेज',
    keyboardHint: '↑ ↓ चुनें · D आज पूरा · H रोकें',
    daysLeft: '{n} दिन में',
    tomorrow: 'कल तक',
    lateBy: '{n} दिन देर',
  },
  projects: {
    title: 'प्रोजेक्ट',
    new: 'नया प्रोजेक्ट',
    import: 'Excel से लाएँ',
    empty: 'अभी कोई प्रोजेक्ट नहीं',
    emptyHint: 'प्रोजेक्ट बनाएँ, या पुरानी ट्रैकर शीट इंपोर्ट करें।',
    noMatch: 'कोई प्रोजेक्ट नहीं मिला।',
    tools: '{n} टूल',
    progress: '{total} में से {done} स्टेज पूरे',
    ends: '{date} को खत्म',
    endsPlan: 'प्लान {plan} · अनुमान {forecast}',
    drafts: 'ड्राफ्ट',
    closed: 'भेजे और बंद',
    showClosed: 'भेजे और रद्द भी दिखाएँ',
    partName: 'पार्ट का नाम',
    partNo: 'पार्ट नं.',
    customer: 'ग्राहक',
    startDate: 'शुरू की तारीख',
    targetDate: 'ग्राहक को वादा',
    targetHint: 'वैकल्पिक — अनुमान के साथ दिखेगा।',
    notes: 'नोट',
    toolsTitle: 'टूल',
    toolsHint:
      'इस पार्ट के लिए ज़रूरी टूल चुनें। अवधि टूल टाइप से आती है; बाद में कोई भी तारीख बदल सकते हैं।',
    addTool: 'टूल जोड़ें',
    toolName: 'टूल का नाम',
    toolNo: 'टूल नं.',
    toolType: 'टूल टाइप',
    noType: 'अन्य (स्टेज की सामान्य अवधि)',
    create: 'ड्राफ्ट बनाएँ',
    created: 'ड्राफ्ट बन गया। तारीखें जाँचें, फिर प्रकाशित करें।',
  },
  project: {
    tracker: 'ट्रैकर',
    timeline: 'टाइमलाइन',
    history: 'इतिहास',
    photos: 'फ़ोटो',
    milestones: 'ट्रायल और शिपिंग',
    plan: 'प्लान',
    actual: 'असली',
    forecast: 'अनुमान',
    baseline: 'बेसलाइन',
    baselineV: 'बेसलाइन v{v}',
    stage: 'स्टेज',
    tool: 'टूल',
    end: 'टूल शिपिंग',
    endPlan: 'प्लान अंत',
    endForecast: 'अनुमानित अंत',
    target: 'वादा {date}',
    draftNote:
      'ड्राफ्ट — सिर्फ़ प्लानर देख सकते हैं। प्रकाशित करने पर प्लान बेसलाइन बन जाता है और काम सबकी सूची में आ जाता है।',
    cancelledNote: 'रद्द। यह किसी की काम-सूची में नहीं दिखता।',
    shippedNote: 'शिपिंग के बाद बंद।',
    publish: 'प्लान प्रकाशित करें',
    publishConfirm: 'प्रकाशित करके बेसलाइन पक्की करने के लिए फिर टैप करें',
    published: 'प्रकाशित। प्लान अब बेसलाइन है और सबकी काम-सूची में है।',
    rebaseline: 'नई बेसलाइन',
    rebaselineTitle: 'मौजूदा प्लान को नई बेसलाइन बनाएँ',
    rebaselineHint: 'जब ग्राहक नई तारीख माने तब इस्तेमाल करें। पुरानी बेसलाइन इतिहास में रहती है।',
    rebaselineReason: 'कारण',
    rebaselined: 'नई बेसलाइन v{v} सेव हुई।',
    planChanged: 'प्लान {n} जगह बेसलाइन से अलग है।',
    addTool: 'टूल जोड़ें',
    addRound: 'ट्रायल राउंड जोड़ें',
    roundLabel: 'नाम (जैसे T3)',
    roundAfter: 'इसके बाद',
    removeTool: 'टूल हटाएँ',
    removeToolConfirm: '{name} हटाने के लिए फिर टैप करें',
    removeStep: 'हटाएँ',
    export: 'Excel निकालें',
    editDetails: 'विवरण बदलें',
    cancelProject: 'प्रोजेक्ट रद्द करें',
    cancelConfirm: '{name} रद्द करने के लिए फिर टैप करें',
    reopen: 'फिर खोलें',
    closeProject: 'भेजा हुआ मानकर बंद करें',
    deleteDraft: 'ड्राफ्ट हटाएँ',
    deleteConfirm: 'ड्राफ्ट हटाने के लिए फिर टैप करें',
    deleted: 'ड्राफ्ट हटा दिया।',
    regenerate: 'तारीखें फिर से निकालें',
    regenerateHint: 'हर खुले स्टेज की तारीख शुरू की तारीख से उसकी अवधि जोड़कर बनेगी।',
    editDate: 'प्लान तारीख',
    moveLater: 'बाद के स्टेज भी खिसकाएँ (अंतर वही रहे)',
    notNeeded: 'इस टूल के लिए ज़रूरी नहीं (लागू नहीं)',
    duration: 'अवधि',
    durationHint: 'पिछले स्टेज के बाद के कार्य दिवस।',
    owner: 'ज़िम्मेदार',
    noOwner: 'अभी कोई ज़िम्मेदार नहीं',
    stepFor: '{stage} · {tool}',
    issues: {
      missing_date: 'कुछ स्टेज की प्लान तारीख नहीं है।',
      before_previous: '{stage} ({tool}) अपने पिछले स्टेज से पहले प्लान है।',
      before_tools: '{stage} सभी टूल पूरे होने से पहले प्लान है।',
      before_start: '{stage} ({tool}) प्रोजेक्ट शुरू होने से पहले प्लान है।',
    },
    photosEmpty: 'अभी कोई फ़ोटो नहीं। स्टेज ओनर काम पूरा करते समय फ़ोटो जोड़ते हैं।',
    historyEmpty: 'अभी कुछ नहीं हुआ।',
    legend: 'ऊपर प्लान (बेसलाइन), नीचे असली या अनुमान।',
    today: 'आज',
    open: 'प्रोजेक्ट खोलें',
  },
  timeline: {
    done: 'पूरा ({date})',
    hold: 'रुका: {reason}',
    release: 'फिर शुरू',
    reopen: 'पूरा नहीं माना',
    note: 'नोट: {note}',
    photo: 'फ़ोटो जोड़ी',
    'plan.edit': 'प्लान बदला',
    'plan.generate': 'तारीखें फिर से निकालीं',
    'project.create': 'प्रोजेक्ट बना',
    'project.import': 'Excel से लाया गया',
    'project.publish': 'प्रकाशित — बेसलाइन v1',
    'project.rebaseline': 'नई बेसलाइन',
    'project.cancelled': 'रद्द',
    'project.active': 'फिर खोला',
    'project.shipped': 'भेजा मानकर बंद',
    'tool.add': 'टूल जोड़ा: {name}',
    'tool.remove': 'टूल हटाया: {name}',
    'milestone.add': 'ट्रायल राउंड जोड़ा',
    'milestone.remove': 'ट्रायल राउंड हटाया',
    notify: 'ज़िम्मेदार को ईमेल से सूचना भेजी',
    undone: 'वापस लिया',
  },
  notify: {
    button: 'सूचना भेजें',
    to: '{name} को सूचना भेजें',
    note: 'सूचना के साथ संदेश',
    notePlaceholder: 'संदेश जोड़ें (वैकल्पिक)',
    sent: '{names} को ईमेल भेजा गया।',
    dummy: '(डेमो: ईमेल अभी सिर्फ़ लॉग होते हैं, भेजे नहीं जाते।)',
    recently: 'आप पिछले 5 मिनट में सूचना भेज चुके हैं।',
    nobody: 'इस स्टेज का अभी कोई ज़िम्मेदार नहीं है। एडमिन से विभाग जुड़वाएँ।',
    offline: 'सूचना भेजने के लिए नेटवर्क चाहिए। ऑनलाइन होने पर फिर कोशिश करें।',
  },
  import: {
    title: 'ट्रैकर शीट इंपोर्ट करें',
    hint: 'वही लेआउट जो आपकी Excel टाइमप्लान में है: Part Name, Operation और Status कॉलम, फिर हर स्टेज का एक कॉलम, और हर टूल की Plan और Actual पंक्ति।',
    pick: '.xlsx फ़ाइल चुनें',
    reading: 'शीट पढ़ी जा रही है…',
    columns: '{total} में से {n} कॉलम स्टेज से मिले',
    unmatched: 'नहीं मिले (छोड़े गए): {list}',
    tools: 'मिले टूल',
    stagesDone: '{n} स्टेज पूरे',
    formula:
      '{n} "Actual" तारीखें सिर्फ़ प्लान की कॉपी (फ़ॉर्मूला) हैं। किसी ने इन्हें भरा नहीं, इसलिए ये पूरी नहीं मानी गईं।',
    acceptFormula: 'फिर भी इन्हें पूरा मानें',
    future: '{n} असली तारीखें भविष्य की थीं, इन्हें छोड़ दिया।',
    before_tools:
      'शीट में {detail} सभी टूल पूरे होने से पहले प्लान है। इंपोर्ट के बाद तारीख ठीक कर सकते हैं।',
    before_previous: 'एक तारीख उल्टी है: {detail}।',
    multiple: 'सिर्फ़ पहला पार्ट इंपोर्ट हुआ। फ़ाइल में और भी हैं: {detail}।',
    noDates: 'शीट में कोई तारीख नहीं मिली।',
    create: 'ड्राफ्ट प्रोजेक्ट बनाएँ',
    created: 'ड्राफ्ट के रूप में आ गया। प्लान जाँचें और प्रकाशित करें।',
    another: 'दूसरी फ़ाइल चुनें',
  },
  dashboard: {
    title: 'डैशबोर्ड',
    projects: 'प्रोजेक्ट',
    attention: 'ध्यान दें',
    attentionHint: 'देरी, रुके हुए और आज तक वाले — पुराने पहले।',
    noAttention: 'कुछ भी देरी में या रुका नहीं है। 👍',
    week: 'अगले 7 दिन में',
    noWeek: 'अगले 7 दिन में कुछ नहीं।',
    upcoming: 'ट्रायल और शिपिंग — अगले 14 दिन',
    noUpcoming: 'अगले 14 दिन में कोई ट्रायल या शिपिंग नहीं।',
    bottleneck: 'समय कहाँ जा रहा है',
    bottleneckHint: 'विभाग अनुसार देरी वाले खुले स्टेज और पिछले 60 दिन में पूरे स्टेज की औसत देरी।',
    overdueN: '{n} देरी',
    holdN: '{n} रुके',
    avgLate: 'औसत {n} दिन देर',
    reports: 'रिपोर्ट',
    all: 'सभी प्रोजेक्ट',
    stagesOverdue: 'देरी वाले स्टेज',
    stagesHold: 'रुके हुए',
    dueToday: 'आज तक',
  },
  display: {
    name: 'फ़्लोर डिस्प्ले',
    cta: 'सभी प्रोजेक्ट टूल रूम के टीवी पर दिखाएँ।',
    open: 'खोलें',
    exit: 'बाहर',
    asOn: '{date} · {time} तक',
    theme: 'लाइट / डार्क बदलें',
  },
  reports: {
    title: 'रिपोर्ट',
    range: 'अवधि',
    last30: 'पिछले 30 दिन',
    last90: 'पिछले 90 दिन',
    thisMonth: 'यह महीना',
    from: 'से',
    to: 'तक',
    statusXlsx: 'स्थिति रिपोर्ट (Excel)',
    statusPdf: 'स्थिति रिपोर्ट (PDF)',
    downloadHint: 'हर चालू प्रोजेक्ट, और हर स्टेज जो देरी में, खतरे में या रुका है।',
    stagesTitle: 'स्टेज अनुसार समय पर',
    deptTitle: 'विभाग अनुसार समय पर',
    holdsTitle: 'रुकने के कारण',
    shippedTitle: 'इस अवधि में भेजे',
    noShipped: 'इस अवधि में कुछ नहीं भेजा।',
    noHolds: 'इस अवधि में कुछ नहीं रुका।',
    noDone: 'इस अवधि में कोई स्टेज पूरा नहीं हुआ।',
    colStage: 'स्टेज',
    colDept: 'विभाग',
    colDone: 'पूरे',
    colOnTime: 'समय पर',
    colSlip: 'औसत देरी',
    colDays: 'लगे / प्लान',
    colCount: 'बार',
    colDate: 'तारीख',
    colVsPlan: 'प्लान से',
  },
  admin: {
    title: 'सेटअप',
    subtitle: '{plant} के लोग, स्टेज, टूल टाइप और डिवाइस',
    users: 'लोग',
    departments: 'विभाग',
    stages: 'स्टेज',
    toolTypes: 'टूल टाइप',
    reasons: 'रुकने के कारण',
    calendar: 'प्लांट और कैलेंडर',
    devices: 'साझा डिवाइस',
    audit: 'ऑडिट लॉग',
    addUser: 'व्यक्ति जोड़ें',
    editUser: 'व्यक्ति बदलें',
    name: 'नाम',
    mobile: 'मोबाइल',
    titleField: 'पद',
    departmentsField: 'विभाग (जिनके स्टेज ये अपडेट करेंगे)',
    departmentsHint: 'स्टेज ओनर सिर्फ़ इन विभागों के स्टेज देखते और अपडेट करते हैं।',
    extField: 'एक्सटेंशन',
    rolesField: 'भूमिका',
    languageField: 'भाषा',
    initialPin: 'अभी PIN सेट करें (प्लांट के फ़ोन के लिए)',
    initialPinHint: 'खाली छोड़ें तो व्यक्ति OTP से खुद PIN बनाएगा।',
    resetPin: 'PIN रीसेट',
    resetPinConfirm: 'फिर टैप करें: {name} अगले लॉग इन पर नया PIN बनाएँगे',
    unlock: 'अनलॉक',
    lockedUntil: '{time} तक लॉक',
    noPinYet: 'PIN नहीं बना',
    inactive: 'बंद',
    active: 'चालू',
    uploadPhoto: 'फ़ोटो लगाएँ',
    saved: 'सेव हो गया',
    addDepartment: 'विभाग जोड़ें',
    nameEn: 'नाम (अंग्रेज़ी)',
    nameHi: 'नाम (हिंदी)',
    addStage: 'स्टेज जोड़ें',
    toolStages: 'टूल स्टेज',
    toolStagesHint: 'हर टूल जिन कॉलम से गुज़रता है, क्रम से।',
    projectStages: 'ट्रायल और शिपिंग',
    projectStagesHint: 'सभी टूल तैयार होने के बाद प्रोजेक्ट के माइलस्टोन, क्रम से।',
    code: 'छोटा नाम',
    codeHint: 'कॉलम हेडर, जैसे VMC या T0।',
    department: 'ज़िम्मेदार विभाग',
    noDepartment: '— सिर्फ़ प्लानर —',
    defaultDays: 'सामान्य अवधि (कार्य दिवस)',
    moveUp: 'ऊपर करें',
    moveDown: 'नीचे करें',
    addToolType: 'टूल टाइप जोड़ें',
    toolTypeName: 'टूल टाइप',
    daysFor: 'हर स्टेज के कार्य दिवस',
    daysHint: 'खाली = स्टेज की सामान्य अवधि · लागू नहीं = इस तरह का टूल यह स्टेज छोड़ता है।',
    na: 'लागू नहीं',
    addReason: 'कारण जोड़ें',
    reasonEn: 'लेबल (अंग्रेज़ी)',
    reasonHi: 'लेबल (हिंदी)',
    icon: 'आइकन',
    maxReasons: 'ज़्यादा से ज़्यादा 8 चालू।',
    plantName: 'प्लांट का नाम',
    timezone: 'टाइमज़ोन',
    weeklyOff: 'साप्ताहिक छुट्टी',
    weeklyOffHint: 'प्लान की अवधि इन दिनों को नहीं गिनती। पुरानी शीट की तरह हर दिन गिनने के लिए सब बंद करें।',
    holidays: 'छुट्टियाँ',
    holidaysHint: 'जिन दिनों टूल रूम बंद रहता है।',
    addHoliday: 'छुट्टी जोड़ें',
    addDevice: 'साझा डिवाइस जोड़ें',
    deviceLabel: 'डिवाइस का नाम',
    deviceRole: 'कौन इस्तेमाल करेगा',
    pairingCode: 'जोड़ने का कोड: {code}',
    pairingHint:
      'डिवाइस पर लॉग इन स्क्रीन खोलें → "टूल रूम के साझा डिवाइस के रूप में सेट करें" और यह कोड डालें। 24 घंटे मान्य।',
    newCode: 'नया कोड',
    paired: '{time} को जुड़ा',
    notPaired: 'अभी नहीं जुड़ा',
    lastSeen: 'आखिरी बार {time}',
    unpair: 'हटाएँ',
    auditWhen: 'कब',
    auditWho: 'किसने',
    auditWhat: 'क्या किया',
    auditEntity: 'रिकॉर्ड',
    loadMore: 'और दिखाएँ',
  },
  weekday: {
    '0': 'रवि',
    '1': 'सोम',
    '2': 'मंगल',
    '3': 'बुध',
    '4': 'गुरु',
    '5': 'शुक्र',
    '6': 'शनि',
  },
  errors: {
    forbidden: 'आपकी भूमिका या विभाग यह नहीं कर सकता।',
    not_found: 'यह अब मौजूद नहीं है।',
    conflict: 'किसी और ने इसे बदल दिया। स्क्रीन अपडेट हो गई है।',
    not_active: 'यह प्रोजेक्ट चालू नहीं है (ड्राफ्ट या बंद)।',
    skipped: 'यह स्टेज इस टूल के लिए लागू नहीं है।',
    bad_date: 'यह तारीख सही नहीं है।',
    future_date: 'पूरा होने की तारीख भविष्य की नहीं हो सकती।',
    before_start: 'यह तारीख प्रोजेक्ट शुरू होने से बहुत पहले की है।',
    locked: 'अगला स्टेज काम कर चुका है। बदलने के लिए प्लानर से कहें।',
    not_done: 'यह पूरा नहीं माना गया है।',
    not_on_hold: 'यह रुका हुआ नहीं है।',
    reason_invalid: 'यह कारण हटा दिया गया। दूसरा चुनें।',
    undo_expired: 'वापस लेने में देर हो गई। "बदलें" इस्तेमाल करें।',
    undo_not_allowed: 'इसे अब वापस नहीं लिया जा सकता।',
    invalid: 'सेव नहीं हुआ। फिर कोशिश करें।',
    network: 'नेटवर्क नहीं। इस डिवाइस पर सेव है; अपने-आप सिंक होगा।',
    rejected: 'सेव नहीं हुआ: {reason}',
  },
  welcome: {
    title: 'अपना प्लांट सेट करें',
    intro: 'नया PACE सर्वर। प्लांट और पहला एडमिन बनाएँ — एक मिनट लगेगा।',
    step: 'चरण {n} / 3',
    codeTitle: 'सेटअप कोड',
    codeHint: 'टीम से मिला 6 अंकों का कोड।',
    codeWrong: 'यह सेटअप कोड सही नहीं है। टीम से मिला कोड जाँचें।',
    plantTitle: 'प्लांट',
    plantName: 'प्लांट का नाम',
    plantNameHint: 'जैसे लोग बोलते हैं, जैसे "फ़रीदाबाद टूल रूम"।',
    timezone: 'टाइमज़ोन',
    weeklyOff: 'साप्ताहिक छुट्टी',
    starterSetup: 'टूल रूम के सामान्य स्टेज (डिज़ाइन → ट्रायल, T0 → शिपिंग), विभाग और टूल टाइप से शुरू करें',
    adminTitle: 'पहला एडमिन',
    adminName: 'एडमिन का नाम',
    adminMobile: 'एडमिन का मोबाइल नंबर',
    adminMobileHint: 'एडमिन इसी नंबर, एक बार के कोड और 4 अंकों के PIN से लॉग इन करेगा।',
    adminJobTitle: 'पद',
    create: 'प्लांट और एडमिन बनाएँ',
    next: 'आगे',
    back: 'वापस',
    done: 'प्लांट बन गया। अब एडमिन खाता चालू करें।',
    otpDefault: 'अभी OTP डिफ़ॉल्ट कोड {code} है (SMS अभी नहीं)।',
    already: 'यह प्लांट पहले से सेट है।',
  },
  onboarding: {
    title: 'शुरुआत',
    intro: 'ये एक बार कर लें, फिर टूल रूम PACE इस्तेमाल कर सकता है।',
    stages: 'स्टेज और उनके ज़िम्मेदार जाँचें',
    stagesHint: 'आपकी ट्रैकर शीट के कॉलम, और हर एक को अपडेट करने वाला विभाग।',
    toolTypes: 'टूल टाइप और उनकी अवधि जाँचें',
    users: 'लोग जोड़ें: प्लानर, स्टेज ओनर, मैनेजमेंट',
    usersHint: 'हर स्टेज ओनर को उसके विभाग दें।',
    calendar: 'साप्ताहिक छुट्टी और त्योहार सेट करें',
    devices: 'टूल रूम का साझा फ़ोन जोड़ें (वैकल्पिक)',
    project: 'प्लानर पहला प्रोजेक्ट बनाए — या ट्रैकर शीट इंपोर्ट करे',
    activate: 'हर व्यक्ति ऐप खोले → "पहली बार?" → मोबाइल → OTP {code} → PIN।',
    go: 'खोलें',
    hide: 'छिपाएँ',
    userAdded: '{name} जुड़ गए। वे ऐप खोलें → पहली बार → अपना मोबाइल → OTP → PIN चुनें।',
  },
  demo: {
    badge: 'डेमो',
    banner: 'डेमो डेटा — नमूना टूल रूम, सबका PIN 1234। यहाँ कुछ भी असली नहीं है।',
    tryIt: 'नमूना डेटा के साथ डेमो देखें →',
    reset: 'डेमो डेटा रीसेट करें',
    realApp: 'असली ऐप पर जाएँ',
    resetDone: 'डेमो नमूना टूल रूम पर रीसेट हो गया।',
  },
  landing: {
    login: 'लॉग इन',
    tryDemo: 'डेमो देखें',
    headline: 'हर टूल, हर स्टेज, प्लान बनाम असली — किसी के पीछे भागे बिना।',
    lede: 'हर स्टेज ओनर फ़ोन पर एक टैप में बताता है कि काम किस दिन पूरा हुआ। प्लान पक्का रहता है, अनुमान अपने-आप आगे बढ़ता है, और ग्राहक ट्रायल से हफ़्तों पहले सबको दिखता है कि कौन सा टूल देर से होगा।',
    heroNote: 'फ़ोन या लैपटॉप ब्राउज़र · कुछ इंस्टॉल नहीं · English और हिंदी',
    howTitle: 'आपकी ट्रैकर शीट, ज़िंदा',
    howLede: 'वही Plan और Actual पंक्तियाँ जो टीम पहले से भरती है — अब काम करने वाले खुद अपडेट करते हैं।',
    stepPlan: 'प्लान',
    stepPlanText: 'प्लानर टूल चुनता है; तारीखें स्टेज की अवधि से बनती हैं। प्रकाशित करते ही बेसलाइन पक्की।',
    stepActual: 'असली',
    stepActualText:
      'डिज़ाइन, VMC, हीट ट्रीटमेंट, वायर कट, असेंबली और ट्रायल — हर कोई "पूरा" टैप करता है, आज का या पिछली तारीख का।',
    stepForecast: 'अनुमान',
    stepForecastText:
      'कहीं भी देरी हो तो आगे की हर तारीख T0 और शिपिंग तक खिसक जाती है। कोई फ़ॉर्मूला दोबारा नहीं लिखना।',
    stepAlert: 'ध्यान',
    stepAlertText:
      'देरी, रुके और खतरे वाले काम डैशबोर्ड पर दिखते हैं, और एक टैप में ज़िम्मेदार को सूचना जाती है।',
    rolesTitle: 'हर भूमिका की एक स्क्रीन',
    rolesLede: 'PIN के बाद हर कोई सीधे अपने काम पर। कोई मेनू सीखना नहीं।',
    roleOwner:
      'स्टेज ओनर: इस हफ़्ते आपके स्टेज में क्या बाकी है। "पूरा" टैप करें, तारीख चुनें, या कारण के साथ रोकें। फ़ोटो जोड़ें।',
    rolePlanner:
      'प्लानर: टूल टाइप से प्रोजेक्ट बनाएँ, शीट जैसे ग्रिड में तारीखें बदलें, प्रकाशित करें। पुराने ट्रैकर इंपोर्ट करें।',
    roleMgmt:
      'मैनेजमेंट: हर प्रोजेक्ट समय पर, खतरे में या देरी में, समय कहाँ जा रहा है, और हफ़्तेवार रिपोर्ट।',
    roleAdmin: 'एडमिन: लोग और उनके विभाग, स्टेज, टूल टाइप, छुट्टियाँ — और टीवी के लिए फ़्लोर डिस्प्ले।',
    floorTitle: 'टूल रूम के लिए बना',
    f1: 'एक टैप',
    f1Text: '"आज पूरा" एक टैप है। पिछली तारीख दो टैप। फ़्लोर पर तारीख टाइप नहीं करनी।',
    f2: 'ऑफ़लाइन भी चले',
    f2Text: 'नेटवर्क जाने पर टैप फ़ोन में सेव रहते हैं और अपने-आप सिंक होते हैं।',
    f3: 'बेसलाइन ईमानदार',
    f3Text: 'जो प्लान वादा किया वह पक्का रहता है। नई बेसलाइन के लिए कारण चाहिए और इतिहास रहता है।',
    f4: 'एक नज़र में पढ़ें',
    f4Text: 'हर स्थिति पर रंग, आइकन और शब्द, बड़े बटन, हिंदी और English।',
    f5: 'Excel अंदर, Excel बाहर',
    f5Text: 'अपनी मौजूदा टाइमप्लान शीट इंपोर्ट करें; कोई भी प्रोजेक्ट उसी लेआउट में निकालें।',
    f6: 'सुरक्षित',
    f6Text: 'PIN लॉग इन, 5 गलत कोशिश पर लॉक, हर बदलाव का ऑडिट, डेटा भारत में।',
    startTitle: 'टूल रूम कैसे शुरू करें',
    s1: 'प्लांट सेट करें',
    s1Text: 'स्टेज, विभाग और टूल टाइप टूल रूम के सामान्य फ़्लो से तैयार मिलते हैं।',
    s2: 'लोग जोड़ें',
    s2Text: 'एडमिन हर व्यक्ति को मोबाइल, भूमिका और विभाग के साथ जोड़ता है।',
    s3: 'सब चालू करें',
    s3Text: 'मोबाइल → एक बार का कोड → 4 अंकों का PIN। उसके बाद सिर्फ़ PIN।',
    ctaTitle: 'नमूना टूल रूम के साथ देखें',
    ctaText:
      'डेमो में पाँच प्रेस-टूल प्रोजेक्ट हैं — Heater Deflector ट्रैकर समेत — आज की तारीख के आसपास। हर नमूना यूज़र का PIN 1234 है।',
    footer: 'SaarthiOS PACE · AI Gurukul Pvt Ltd',
    previewTitle: 'Heater Deflector · 6 टूल',
    previewPlan: 'प्लान',
    previewForecast: 'अनुमान',
    previewLate: '+5 दिन',
  },
  a11y: {
    delete: 'अंक हटाएँ',
    menu: 'प्रोफ़ाइल खोलें',
    close: 'बंद करें',
    skip: 'सामग्री पर जाएँ',
  },
};
